module.exports = __webpack_public_path__ + "img/xny1_mb.6793a528.jpg";